/**
 * Set or remove the `inert` attribute on an element.
 *
 * @param element The element to set or remove the `inert` attribute on.
 * @param enabled Whether to set or remove the `inert` attribute.
 */
function setInertAttribute(element: Element, enabled: boolean) {
  if (enabled) {
    const current = element.getAttribute('inert')

    // store previous value
    if (current !== null) {
      element.setAttribute('data-n-inert', current)
    }

    element.setAttribute('inert', '')
  }
  else {
    const current = element.getAttribute('data-n-inert')

    // restore previous value if necessary
    if (current !== null) {
      element.setAttribute('inert', current)
      element.removeAttribute('data-n-inert')
    }
    else {
      element.removeAttribute('inert')
    }
  }
}

/**
 * Set or remove the `inert` attribute on all given elements.
 *
 * @param elements The elements to set or remove the `inert` attribute on.
 * @param enabled Whether to set or remove the `inert` attribute.
 */
export function setInertAttributes(elements: Element[], enabled: boolean) {
  elements.forEach(element => setInertAttribute(element, enabled))
}

/**
 * Get all siblings of an element, including the siblings of its parents.
 * Use this to find all elements that should be inert when a modal is open.
 * And then use `setInertAttributes` to set or remove the `inert` attribute
 * on all of them.
 */
export function getElementsAround(element: Element): Element[] {
  const elements = []
  let next = element.nextElementSibling

  while (next) {
    elements.push(next)
    next = next.nextElementSibling
  }

  next = element.previousElementSibling

  while (next) {
    elements.push(next)
    next = next.previousElementSibling
  }

  if (element.parentElement && element.parentElement !== document.body) {
    elements.push(...getElementsAround(element.parentElement))
  }

  return elements
}
